<template>
  <div class="login">
    <div class="login-con shadow">
      <el-image
        class="login-img"
        fit="cover"
        :src="require('@/assets/img/login-img.jpg')"
      ></el-image>
      <div class="right">
        <div class="title">
          <el-image
            class="logo-img"
            :src="require('@/assets/img/logo-bd2.png')"
            fit="contain"
          />
          <h2>宝达集团人资管理系统</h2>
        </div>
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          size="large"
          status-icon
        >
          <el-form-item label="" prop="account">
            <el-input v-model="ruleForm.account" :prefix-icon="User" />
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model="ruleForm.password"
              type="password"
              :prefix-icon="Lock"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              class="main-btn main-btn-primary"
              type="primary"
              @click="submitForm(ruleFormRef)"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouter } from 'vue-router';
import { User, Lock } from "@element-plus/icons-vue";
import {fetchLocalKey, login, userInfo} from "@/api/user";

const $router = useRouter();

const ruleFormRef = ref();
const ruleForm = reactive({
  account: "",
  password: "",
});

const rules = reactive({
  account: [{ required: true, message: "请输入账号", trigger: "blur" }],
  password: [{ required: true, message: "请输入密码", trigger: "blur" }],
});
import axios from 'axios'
const submitForm = async (formEl) => {
    let tid, enStr;
    tid = Date.parse(new Date())
    axios.get('http://localhost:3113/?funname=xjkOpenKeyEx&cUserName=&cPassWord=888888',
        { timeout: 1000 }
    ).then(() => {
    }).finally(() => {
        //获取时间戳
        axios.get('http://localhost:3113/?funname=xjkGetEnStr&cDataIn='+tid,
            { timeout: 1000 }
        ).then((res) => {
            enStr = res.data
        }).finally(() => {
            requestLogin(formEl, tid, enStr)
        });
    });
};

const requestLogin = async (formEl, tid, enStr) => {
    if (!formEl) return;
    let param = {
        account: ruleForm.account,
        password: ruleForm.password,
        tid: tid,
        enStr: enStr
    }
    await formEl.validate((valid, fields) => {
        if (valid) {
            login(param).then((res) => {
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("name", res.data.name);
                getUserinfo();
            });
            console.log("submit!");
        } else {
            console.log("error submit!", fields);
        }
    });
};

const getUserinfo = async () => {
    userInfo().then((res) => {
        let powers = res.data.powers.toString();
        localStorage.setItem("powers", powers);
        $router.push("/home");
    });
};
</script>

<style lang='scss'>
//scss
</style>
